<div
  data-cy="edit-driving-license-form"
  class="cpt-modal relative dialog-content-p-0 mat-dialog-actions-pb-20 ef-scrollbar"
  >
  @if (imgType === 'front') {
    <h2
      class="font-canelablack-primary text-4xl"
      mat-dialog-title
      >
      <T
      str="Edit driver's license front"
      key="customerPortal.customer-portal.details.update-avatar-popup.title-licence-front"
      tags="customer-portal, 3.1"
    ></T>
  </h2>
}
@if (imgType === 'back') {
  <h2
    class="font-canelablack-primary text-4xl"
    mat-dialog-title
    >
    <T
    str="Edit driver's license back"
    key="customerPortal.customer-portal.details.update-avatar-popup.title-licence-back"
    tags="customer-portal, 3.1"
  ></T>
</h2>
}

<mat-divider></mat-divider>

<mat-dialog-content class="mat-typography">
  <div class="flex">
    <!-- *ngIf="!disabled" -->
    <div
      class="image-preview relative w-full h-60 cover curor-pointer bg-mat-ef-revolution-grey-200"
      >
      @if (!disabled && showDeleteButton) {
        <div
          data-cy="delete-driving-license"
          class="absolute top-2 right-2 bg-mat-ef-revolution-red-500 shadow-xl h-10 w-10 rounded-full cursor-pointer z-50 flex justify-center items-center"
          (click)="deleteImage()"
          >
          <mat-icon svgIcon="delete" class="text-white"></mat-icon>
        </div>
      }
      @if (!disabled && preview) {
        <img
          alt="image preview"
          class="cover"
          [src]="preview"
          />
      }
      @if (!disabled && !preview && imgUrl) {
        <img
          class="cover"
          [src]="imgUrl"
          alt="image preview"
          />
      }
      <input
        data-cy="edit-driving-license-input"
        class="opacity-0 absolute top-0 h-full w-full z-30 cursor-pointer"
        type="file"
        accept=".jpg, .png"
        (change)="loadImage($event)"
        />
      <div class="flex justify-center">
        @if (disabled) {
          <div
            class="absolute text-center inset-y-1/2 flex flex-col justify-center"
            >
            <div>
              <mat-icon
                svgIcon="add_photo_alternate"
                class="text-mat-ef-revolution-primary-500"
                >
              </mat-icon>
            </div>
            <!-- prettier-ignore -->
            <p
              class="font-bold font-efSans-primary"
            [innerHtml]="getTranslation()"></p>
            <p
              class="font-efSans text-mat-ef-revolution-grey-two-200 text-base font-normal grid"
              >
              <span class="grid">
                <span>
                  <T
                  str="Supported formats: JPG, BMP, PNG (max. {maxSize} MB)"
                  key="customerPortal.customer-portal.supported-formats.maxSize"
                  tags="customer-portal, 3.1"
                  [vars]="{ maxSize: maxSize }"
                ></T>
              </span>
              <span>
                <T
                str="Recommended resolution 1024 x 1024 px"
                key="customerPortal.customer-portal.details.update-avatar-popup.file-resolution"
                tags="customer-portal, 3.1"
              ></T>
            </span>
          </span>
          @if (!propperSize) {
            <mat-error>
              <T
              str="Maximum file size exceeded."
              key="customerPortal.customer-portal.details.update-avatar-popup.incorrect-size"
              tags="customer-portal, 3.1"
            ></T>
          </mat-error>
        }
        @if (!propperFileNameLength) {
          <mat-error>
            <T
            str="Maximum filename length excceeded"
            key="customerPortal.customer-portal.vehicle.documents-upload.error.maxlength"
            tags="customer-portal, 3.1"
          ></T>
        </mat-error>
      }
    </p>
  </div>
}
</div>
</div>
</div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions class="justify-between gap-4">
  <div
    class="avatar-details float-left text-mat-ef-revolution-grey-two-500 text-sm"
    >
    @if (imgUrl || preview) {
      <p class="upload-note">
        <T
        str="Supported formats: JPG, BMP, PNG (max. {maxSize} MB)"
        key="customerPortal.customer-portal.supported-formats.maxSize"
        tags="customer-portal, 3.1"
        [vars]="{ maxSize: maxSize }"
      ></T>
      <br />
      <T
      str="Recommended resolution 1024 x 1024 px"
      key="customerPortal.customer-portal.details.update-avatar-popup.file-resolution"
      tags="customer-portal, 3.1"
    ></T>
    <br />
    @if (!propperSize) {
      <mat-error class="mat-form-field p-0">
        <T
        str="Maximum file size exceeded."
        key="customerPortal.customer-portal.details.update-avatar-popup.incorrect-size"
        tags="customer-portal, 3.1"
      ></T>
    </mat-error>
  }
  @if (!propperFileNameLength) {
    <mat-error
      class="mat-form-field p-0"
      data-cy="edit-driving-license-error-maxFileName"
      >
      <T
      str="Maximum filename length excceeded"
      key="customerPortal.customer-portal.vehicle.documents-upload.error.maxlength"
      tags="customer-portal, 3.1"
    ></T>
  </mat-error>
}
</p>
}
</div>

<button class="dialog-close-button" [mat-dialog-close]="false">
  <mat-icon svgIcon="close"></mat-icon>
</button>
<button
  data-cy="edit-driving-license-submit"
  (click)="save()"
  id="saveButton"
  class="revolution"
  mat-button
  mat-flat-button
  color="secondary"
  cdkFocusInitial
      [disabled]="
        disabled || savingInProgress || !propperFileNameLength || !originalFile
      "
  >
  @if (savingInProgress) {
    <mat-spinner [diameter]="16"></mat-spinner>
  }
  {{ 'save' | sharedTranslate }}
</button>
</mat-dialog-actions>
</div>
